var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFindKfc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6.05c0-.303.248-.55.55-.55.302 0 .55.247.55.55v3.3c0 .913-.737 1.65-1.65 1.65H1.65C.737 11 0 10.263 0 9.35V3.3c0-.913.737-1.65 1.65-1.65h3.3c.303 0 .55.247.55.55 0 .302-.247.55-.55.55h-3.3a.552.552 0 0 0-.55.55v6.05c0 .302.247.55.55.55H7.7c.302 0 .55-.248.55-.55v-3.3zM9.9 1.1H7.15A.552.552 0 0 1 6.6.55c0-.303.247-.55.55-.55h3.3c.303 0 .55.247.55.55v3.3c0 .302-.248.55-.55.55a.552.552 0 0 1-.55-.55V1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79 6.99a.548.548 0 1 1-.775-.775l6.05-6.05a.548.548 0 1 1 .776.775L4.79 6.99z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindKfc);
export default __webpack_public_path__ + "static/media/findKFC.f57afcda4568cc61eab97615bd825383.svg";
export { ForwardRef as ReactComponent };